module.exports = __webpack_public_path__ + "img/link-faq-desktop_en.0d2ce53.jpg";